import { OnInit, OnDestroy, Component, Inject, Optional } from '@angular/core';
import { IContextService, DomainContext } from '@pershing/pershing-core';
import { Subscription } from 'rxjs';
import { NxiRestService } from '../../services/NXI-Rest.service';
import { NxiWidgetParamsService } from '../../services/NXI-WidgetParams.service';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { NxiContextUtils } from '@pershing/nxi-common';

declare let dojoApp: any;

@Component({
    selector: 'dojo-ugl-grid',
    templateUrl: './dojo-ugl-grid.component.html'
})
export class DojoUglGridComponent implements OnInit, OnDestroy {
    inputValue: string = '';
    domain: string = '';
    subs: Subscription;
    acctRef: any;
    appSettings: any;
    title: string;
    realTimeActive: boolean = false;
    constructor(private contextService: IContextService,
                private nxiRestService: NxiRestService,
                private location: Location,
                private nxiWidgetParamsService: NxiWidgetParamsService,
                private route: ActivatedRoute,
                @Optional() @Inject('AppSettings') appSettings: any) {
                    this.appSettings = appSettings;
    }

    ngOnInit() {
        this.subs = this.contextService.selectedDomainContext$.subscribe((domainContext: DomainContext<any>) => {
            let contextValue = NxiContextUtils.getContextFromDomainValue(domainContext);
            this.inputValue = contextValue.inputValue;
            this.acctRef = contextValue.hashValue;
            this.route.queryParams.subscribe(params => {
                if (params.rt) {
                    this.realTimeActive = params.rt;
                }
            });
            this.getUglGrid();
        });
    }

    ngOnDestroy(): void {
        console.log('In dojo UGL grid destroy method');
        if (this.subs) {
            this.subs.unsubscribe();
        }
        if (dojoApp) {
            // pass necessary parameters to render dojo widgets
            dojoApp.destroyUglGrid();
        }
    }
    renderDojoWidget(uglGridDojoParams: any) {
        let require: any = window['require'];
        let comp: any = this;
        if (dojoApp) {
            require(['dojo/ready'], function (ready) {
                require(['dijit/dijit'],
                    function (dijit) {
                        if (comp.retiveQueryString('symbol') && dijit.byId('UGLDetailsPopup')) {
                            try {
                              dijit.byId('UGLDetailsPopup').destroyRecursive();
                            } catch (err) {
                              console.error('Error while destroying liabilities-details');
                            }
                          }
                    });
            });
            // pass necessary parameters to render dojo widgets
            dojoApp.renderUglGrid(this.inputValue, uglGridDojoParams);
        }
    }
    retiveQueryString (field) {
        let href =  window.location.href;
        let reg = new RegExp( '[?&]' + field + '=([^&#]*)', 'i' );
        let param = reg.exec(href);
        return param ? param[1] : null;
    }
    getUglGrid() {
        if (this.acctRef) {
            if (sessionStorage.getItem('realTimeActive') && 'true' === sessionStorage.getItem('realTimeActive')) {
                this.realTimeActive = true;
            } else {
                this.realTimeActive = false;
            }
            this.nxiWidgetParamsService.getWidgetParams(this.acctRef, 'ugl?realtimeQuote=' + this.realTimeActive).subscribe(
                resp => {
                    console.log('Retrived common REST Holdings Grid params : ', resp.response);
                    if (resp.response) {
                        resp.response.storeUrl = this.nxiRestService.serviceUrl + resp.response.storeUrl;
                        // need to make necessary changes in the webapps & nxi-core to read this ibdconfigmap as json.
                        resp.response.modAPIUrl = this.appSettings.ibdConfigMap.modApiUrl;

                        resp.response.nxiRestBaseUrl = this.nxiRestService.serviceUrl;
                        let queryparam = this.route.snapshot.queryParams;
                        if (queryparam && queryparam.symbol) {
                            resp.response.symbol = decodeURIComponent(queryparam.symbol);
                        }
                        this.renderDojoWidget(resp.response);
                    }
                }
            );
        }
    }
}
